import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HomeHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/home/home-hero-section';
import { WhyRedeBins } from '@trashlab/sitesapp/src/organizations/redebins/template/components/home/why-redebins';
import { HowItWorks } from '@trashlab/sitesapp/src/organizations/redebins/template/components/home/how-it-works';
import { ProductCards } from '@trashlab/sitesapp/src/organizations/redebins/template/components/home/product-cards';
import { JunkRemovalPromo } from '@trashlab/sitesapp/src/organizations/redebins/template/components/home/junk-removal-promo';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const HomePage = () => {
  return (
    <>
      <HomeHeroSection />
      <WhyRedeBins />
      <HowItWorks />
      <ProductCards />
      <JunkRemovalPromo />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

